// DEV-4720: the assign/reassign user picker for a broker is fed by GET /sub-companies/{id}/users
// (server-scoped to the caller's subtree), mapped to the same { name, value } option shape the
// autocomplete + submit handler expect (user.name / user.value).
export const mapSubCompanyUsersToOptions = (users = []) =>
  (users || []).map(user => ({
    name: [user.firstName, user.lastName].filter(Boolean).join(' ') || user.email || user.id,
    value: user.id,
  }));
